module.exports = __webpack_public_path__ + "static/img/upLoading.34cc62d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upLoading.gif
// module id = SBPU
// module chunks = 2